var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-detail"},[(_vm.isFinsih)?[_c('span',{staticClass:"release-date u-flex u-row-right"},[_vm._v(" "+_vm._s(`${_vm.$t("releaseDate")}: ${_vm.params.publishDate}`)+" ")]),_c('p',[_vm._v(_vm._s(_vm.params.intro))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }